export default "__VITE_ASSET__BW2zex0X__"